var React = require('react');

function IconExpandAll (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M401.5 587.5l31.1 31.1c3.9 3.9 3.9 10.2 0 14.1L169.1 896.2h265.5c5.5 0 10 4.5 10 10v43.3c0 5.5-4.5 10-10 10H71.2c-5.5 0-10-4.5-10-10V586.1c0-5.5 4.5-10 10-10h44.2c5.5 0 10 4.5 10 10v263.6l261.9-262.2c3.9-3.9 10.3-3.9 14.2 0zM620.5 438.7l-31.1-31.1c-3.9-3.9-3.9-10.2 0-14.1L852.9 130H587.4c-5.5 0-10-4.5-10-10V76.7c0-5.5 4.5-10 10-10h363.4c5.5 0 10 4.5 10 10v363.5c0 5.5-4.5 10-10 10h-44.2c-5.5 0-10-4.5-10-10V176.6L634.7 438.7c-3.9 3.9-10.3 3.9-14.2 0z"}));
}

IconExpandAll.displayName = "IconExpandAll";

IconExpandAll.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconExpandAll;

IconExpandAll.default = IconExpandAll;
